const acceptable_regEx = /^[a-z0-9\-\_\:]+$/;
const acceptable_description_regEx = /^[a-zA-Z0-9 \-\:\.\,\!\?\;\'\"\(\)\/]+$/;

export const validateLabel = (label, isEdit, isSubmit) => {
  if (label.length == 0 && (isEdit || isSubmit)) {
    return "Missing required field 'label'.";
  }
  if (!acceptable_regEx.test(label)) {
    return "Label is invalid. Can only contain lowercase letters, numbers, '-', '_' and ':'";
  }
  if (label.length < 3 && (isEdit || isSubmit)) {
    return "Label is too short. Cannot be shorter than 3 characters.";
  }
  if (label.length > 50) {
    return "Label is too long. Cannot be longer than 50 characters.";
  }
};

export const validateNamespace = (nameSpace, isEdit, isSubmit) => {
  if (!acceptable_regEx.test(nameSpace) && nameSpace.length !== 0) {
    return "Namespace is invalid. Can only contain lowercase letters, numbers, '-', '_' and ':'";
  }
  if (nameSpace.length >= 1 && nameSpace.length < 3 && (isEdit || isSubmit)) {
    return "Namespace is too short. Cannot be shorter than 3 characters.";
  }
  if (nameSpace.length > 50) {
    return "Namespace is too long. Cannot be longer than 50 characters.";
  }
};

export const validateDescription = (description, isEdit, isSubmit) => {
  if (!acceptable_description_regEx.test(description) && description.length !== 0) {
    return `Description is invalid. Can only contain letters, numbers, characters like . , ! ? : ; ' " ( ) - / and spaces`
  }
  if (description.length == 0 && (isEdit || isSubmit)) {
    return "Missing required field 'description'.";
  }
  if (description.length < 10 && (isEdit || isSubmit)) {
    return "Description is too short. Cannot be shorter than 10 characters.";
  }
  if (description.length > 250) {
    return "Description is too long. Cannot be longer than 250 characters.";
  }
};
